import { setDisplayErrorSnackBar } from "../../features/userSlice";
import store from "../../store";

// Recursive function to check if a permission exists in userPermissions
const hasPermission = (permissionKey: any, userPermissions: any): boolean => {
  // Loop through all keys at the current level
  for (const key in userPermissions) {
    if (userPermissions.hasOwnProperty(key)) {
      const permissionList = userPermissions[key];

      // If the permissionList is an array, check if any object contains the permissionKey
      if (
        permissionList !== null &&
        (Array.isArray(permissionList) || typeof permissionList === "object")
      ) {
        if (permissionKey) {
          if (permissionList.hasOwnProperty(permissionKey)) {
            return true;
          }
        }
        if (hasPermission(permissionKey, permissionList)) {
          return true;
        }
      }
    }
  }
  // If not found, return false
  return false;
};

// Recursive function to filter the menu config based on user permissions
export const checkVisibility = (menuConfig: any, userPermissions: any) => {
  try {
    return menuConfig
      .map((item: any) => {
        let isItemVisible;

        // If item has children, check them as well
        if (item?.children) {
          const visibleChildren = checkVisibility(
            item.children,
            userPermissions
          );

          // Only show parent if any of the children are visible
          if (visibleChildren.length > 0 || isItemVisible) {
            return {
              ...item,
              children:
                visibleChildren.length > 0 ? visibleChildren : undefined,
            };
          }
        }

        // Check if the item has permissions (parent or child)
        if (item.permission) {
          if (!Array.isArray(item?.permission)) {
            isItemVisible = item.permission
              ? hasPermission(item.permission, userPermissions)
              : true;
          } else {
            isItemVisible = item?.permission
              ? item?.permission?.map((per: any) =>
                  hasPermission(per, userPermissions)
                )
              : true;
          }
        }

        // Return the item if it's visible (either parent or child)
        if (Array.isArray(isItemVisible)) {
          let flag = true;
          // eslint-disable-next-line
          isItemVisible.map((itemMenu: any) => {
            if (!itemMenu) {
              flag = false;
            }
          });

          if (flag === true) {
            return item;
          }
        } else {
          if (isItemVisible) {
            return item;
          }
        }

        // If not visible, return null
        return null;
      })
      .filter((item: any) => item !== null); // Filter out the null values (items without permission)
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "error occurred while building menu",
        type: "error",
      })
    );
  }
};
